import { Controller } from "@hotwired/stimulus"
import { rememberTimeZone } from "../lib/field_start_rule"

// Remembers the signed-in Tasker's IANA time zone on this device so the offline
// shell can decide what "today" means for the Start rule (card #4152). Mounted on
// <body> of the online field layout; the offline shell page renders no value.
export default class extends Controller {
  static values = { iana: String }

  connect() {
    if (this.ianaValue) rememberTimeZone(this.ianaValue)
  }
}
